import { createRouter, createWebHistory } from 'vue-router'
import StoreView from '../views/StoreView.vue'
import HomeView from '../views/HomeView.vue'
import FormView from '../views/FormView.vue'
import AdminSubmissions from '../views/Admin.vue'

const routes = [
  {
    path: '/',
    name: 'store',
    component: StoreView,
    meta: {
      title: 'Apple Authorized Reseller - Tienda Oficial & Ofertas Exclusivas',
      description: 'Compra los últimos modelos de iPhone 18 Pro, MacBook Pro M4, iPad Pro, Apple Watch y AirPods con garantía oficial de distribuidor autorizado.',
      canonical: 'https://appleredeem.store/',
      robots: 'index, follow, max-image-preview:large'
    }
  },
  {
    path: '/store',
    redirect: '/'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Apple - Presentamos Apple Intelligence & Nuevos Dispositivos',
      description: 'Descubre la nueva era de Apple Intelligence en iPhone 18, Mac y iPad. Inteligencia personal y privada para potenciar tu día a día.',
      canonical: 'https://appleredeem.store/home',
      robots: 'index, follow, max-image-preview:large'
    }
  },
  {
    path: '/form',
    name: 'form',
    component: FormView,
    meta: {
      title: 'Conectar con un Especialista - Apple Authorized Reseller',
      description: 'Asesoramiento personalizado con Especialistas Apple para elegir tu próximo dispositivo, configurar tu equipo y acceder a ofertas exclusivas.',
      canonical: 'https://appleredeem.store/form',
      robots: 'index, follow, max-image-preview:large'
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminSubmissions,
    meta: {
      title: 'Portal de Administración - Apple Authorized Reseller',
      description: 'Panel privado de administración de solicitudes.',
      canonical: 'https://appleredeem.store/admin',
      robots: 'noindex, nofollow'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  // Update Title
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  // Update Meta Description
  let metaDesc = document.querySelector('meta[name="description"]')
  if (!metaDesc) {
    metaDesc = document.createElement('meta')
    metaDesc.setAttribute('name', 'description')
    document.head.appendChild(metaDesc)
  }
  if (to.meta && to.meta.description) {
    metaDesc.setAttribute('content', to.meta.description)
  }

  // Update Meta Robots (e.g. noindex for /admin)
  let metaRobots = document.querySelector('meta[name="robots"]')
  if (!metaRobots) {
    metaRobots = document.createElement('meta')
    metaRobots.setAttribute('name', 'robots')
    document.head.appendChild(metaRobots)
  }
  if (to.meta && to.meta.robots) {
    metaRobots.setAttribute('content', to.meta.robots)
  }

  // Update Canonical Link
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }
  if (to.meta && to.meta.canonical) {
    canonicalLink.setAttribute('href', to.meta.canonical)
  }

  // Update Open Graph tags dynamically
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle && to.meta && to.meta.title) {
    ogTitle.setAttribute('content', to.meta.title)
  }

  const ogDesc = document.querySelector('meta[property="og:description"]')
  if (ogDesc && to.meta && to.meta.description) {
    ogDesc.setAttribute('content', to.meta.description)
  }

  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl && to.meta && to.meta.canonical) {
    ogUrl.setAttribute('content', to.meta.canonical)
  }
})

export default router
